
(() => {
  const ROOT_SELECTOR = '.language-selector--custom';

  function syncLabel(root) {
    const select = root.querySelector('select[name="language_code"]');
    const valueEl = root.querySelector('[data-localization-value]');
    if (!select || !valueEl) return;

    const opt =
      select.options && select.selectedIndex >= 0
        ? select.options[select.selectedIndex]
        : null;

    const label = opt && opt.textContent ? opt.textContent.trim() : '';
    if (label) valueEl.textContent = label;
  }

  function closeMenu(root) {
    const trigger = root.querySelector('[data-localization-trigger]');
    const menu = root.querySelector('[data-localization-menu]');
    if (!trigger || !menu) return;
    menu.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    root.dataset.open = 'false';
  }

  function openMenu(root) {
    const trigger = root.querySelector('[data-localization-trigger]');
    const menu = root.querySelector('[data-localization-menu]');
    if (!trigger || !menu) return;
    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    root.dataset.open = 'true';
  }

  function init(root) {
    if (!root) return;

    // If theme replaced the DOM node, this will be a fresh element and will init again.
    if (root.dataset.customLangInit === '1') {
      // Still resync label (in case options got populated later)
      syncLabel(root);
      return;
    }
    root.dataset.customLangInit = '1';

    const select = root.querySelector('select[name="language_code"]');
    const trigger = root.querySelector('[data-localization-trigger]');
    const menu = root.querySelector('[data-localization-menu]');
    if (!select || !trigger || !menu) return;

    // Hydration timing: try a few times after init (cheap + safe)
    syncLabel(root);
    setTimeout(() => syncLabel(root), 0);
    setTimeout(() => syncLabel(root), 100);
    setTimeout(() => syncLabel(root), 300);
    setTimeout(() => syncLabel(root), 800);

    select.addEventListener('change', () => syncLabel(root), { passive: true });

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (menu.hidden) openMenu(root);
      else closeMenu(root);
    });

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-localization-option]');
      if (!btn) return;

      const next = btn.getAttribute('data-value');
      if (!next) return;

      select.value = next;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      root.querySelectorAll('[data-localization-option]').forEach((b) => {
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });

      syncLabel(root);
      closeMenu(root);
    });

    // Close on outside click / ESC (global, but safe)
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target) && !menu.hidden) closeMenu(root);
    }, { passive: true });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !menu.hidden) closeMenu(root);
    }, { passive: true });

    closeMenu(root);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  // Run on initial load
  onReady(initAll);

  // Run when Shopify theme editor loads/rerenders sections (also fires on some storefront rehydrates)
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:section:select', initAll);

  // Many themes update header on navigation; catch late header renders
  window.addEventListener('load', initAll);

  // If the theme uses AJAX navigation, history changes can replace header without full reload
  window.addEventListener('popstate', initAll);
})();

